/**
 * Created by Markus on 15.6.2015.
 */

define('helperNavigation-isLevel1',[],function() {
    'use strict';

    var isLevel1 = function(ID, arr) {
        var level1 = false;

        if (!ID || !Array.isArray(arr)) {
            return null;
        }

        arr = [].concat(arr);

        if(arr.length > 0) {
            level1 = (arr.some(function (entity) {
                // console.log(entity.contentEntityId +" === "+ ID +": ", entity.contentEntityId === ID);
                if (entity.hasOwnProperty('contentEntityId') && entity.contentEntityId === ID) {
                    return true;
                }
            })) ? true: false;
        }

        return level1;
    };

    return isLevel1;

});

